var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh"}},[(_vm.timeout)?_c('empty-box',{attrs:{"text":"页面过期啦~"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }